// extracted by mini-css-extract-plugin
module.exports = {"button":"_10fd156","active":"_8060e30","link":"_5515782"};